import React from 'react';
import {FastField, ErrorMessage} from 'formik';
import {get, kebabCase} from 'lodash';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import FormRow from '../FormRow';
import FormGroup from '../FormGroup';
import Error from '../../../Error';
import RichEditorField from '../../../rte/RichEditorField';
import {previousQuestionsSupportingExpressions} from '../../../../services/conditionBuilders';

const CommonFields = ({name, form, required, showSubtitle = true, previousPages}) => {
    const questions = previousQuestionsSupportingExpressions(previousPages);
    return (
        <>
            <div className="row">
                <FormGroup name={`${name}.id`} label={messages.surveys.form.label.questionId} size={3} tooltip={messages.surveys.form.tooltip.questionId}>
                    <FastField id={`${name}.id`} name={`${name}.id`} type="text"
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.id`) && get(form.touched, `${name}.id`)})} />
                    <ErrorMessage name={`${name}.id`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormGroup>
                {required &&
                    <div className="form-inline">
                        <FastField id={`${name}.required`} name={`${name}.required`}>
                            {({field}) => (
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" name={`${name}.required`} id={`${name}.required`} className="custom-control-input"
                                        checked={field.value} onChange={field.onChange} />
                                    <label className="custom-control-label" htmlFor={`${name}.required`} id={kebabCase(`${name}.required.label`)}>
                                        <FormattedMessage {...messages.surveys.form.label.required} />
                                    </label>
                                </div>
                            )}
                        </FastField>
                    </div>
                }
            </div>

            <FormRow name={`${name}.title`} label={messages.surveys.form.label.title} tooltip={messages.surveys.form.tooltip.title}>
                <FastField id={`${name}.title`} name={`${name}.title`} component={RichEditorField} hasImage
                    questions={questions}
                    className={classNames('form-control',
                        {error: get(form.errors, `${name}.title`) && get(form.touched, `${name}.title`)})} />
                <ErrorMessage name={`${name}.title`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
            </FormRow>
            {showSubtitle &&
                <FormRow name={`${name}.subtitle`} label={messages.surveys.form.label.subtitle} tooltip={messages.surveys.form.tooltip.subtitle}>
                    <FastField id={`${name}.subtitle`} name={`${name}.subtitle`} type="text"
                        className={classNames('form-control',
                            {error: get(form.errors, `${name}.subtitle`) && get(form.touched, `${name}.subtitle`)})} />
                    <ErrorMessage name={`${name}.subtitle`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </FormRow>
            }
        </>
    );
};

export default CommonFields;
